import { FC } from "react";
import { NumberContainer, NumberText } from "./styled";

interface CustomNumberProps {
  label: string;
  bottom?: string;
  color?: string;
}

const CustomNumber: FC<CustomNumberProps> = ({ label, bottom, color }) => {
  return (
    <NumberContainer bottom={bottom}>
      <NumberText color={color}>{label}</NumberText>
    </NumberContainer>
  );
};

export default CustomNumber;
